import AOS from 'aos';

AOS.init({
    duration: 800
});